import { ComponentProps, useMemo } from 'react';

import { CurrencyAccountSelect } from '@/features/account-select';

import { useTotalBalanceStore } from '@/entities/currency-account';
import { WidgetSchemaAccount } from '@/entities/widget';

import { ArrowUpRight, Plus2 } from '@/shared/assets';
import { AppImage, ArrowOpener, Button, Heading, Skeleton } from '@/shared/ui';

import { useCustomizationStore } from '../../model/store';
import { AddMoneyFlowModal } from './add-flow';
//import { useAddMoney } from '../../model/useAddMoney';
import { SendMoneyFlowModal } from './send-money-flow';
// TODO: restore Exchange
// import { useExchangeNavigation } from '@/shared/lib';

interface CardsWidgetProps {
  accountSelectProps?: Omit<
    ComponentProps<typeof CurrencyAccountSelect>,
    'selected' | 'onSelect'
  >;
  widget?: WidgetSchemaAccount;
  onAddAccount?: VoidFunction;
  isTotal?: boolean;
}

export const CardsWidget = ({
  accountSelectProps,
  onAddAccount,
  account,
  setAccount,
  //totalBalance = 0,
  isTotal,
}: CardsWidgetProps) => {
  const totalBalance = useTotalBalanceStore(
    (state) => state.totalBalance,
  )?.amount;
  // TODO: restore Exchange
  // const { handleGoToExchange } = useExchangeNavigation();
  //const resetAddData = useAddMoney((state) => state.resetAddData);
  const widgets = useCustomizationStore((state) => state.accountsBgs);
  const widget = useMemo(
    () =>
      widgets?.find((i) =>
        account?.id === 'all' ? i.id === account?.id : i.id === account?.code,
      ),
    [account],
  );
  return (
    <>
      <div className="flex h-full w-full flex-col items-center pt-[200px]">
        <AppImage
          className="absolute left-0 top-0 h-full max-h-[200px] w-full rounded-6xl object-cover"
          fallback={
            <Skeleton className="absolute left-0 top-0 h-[200px] w-full rounded-6xl" />
          }
          src={widget?.background || account?.imgSrc}
          alt=""
        />

        <div className="flex h-[108px] w-full justify-between">
          <div className="flex flex-col justify-between">
            <div
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {account && (
                <CurrencyAccountSelect
                  hasRequested={isTotal}
                  selected={account}
                  onSelect={setAccount}
                  onAddAccount={onAddAccount}
                  isWide
                  customTrigger={
                    <ArrowOpener>
                      {account?.id === 'all'
                        ? 'All accounts'
                        : `Account ${account.code}`}
                    </ArrowOpener>
                  }
                  {...accountSelectProps}
                />
              )}
            </div>

            <Heading variant="l" tag="span" className="text-start">
              {account?.id === 'all' ? totalBalance || '0' : account?.value}
              &#8239;
              {account?.symbol}
            </Heading>
          </div>

          <div
            className="flex h-full items-end gap-x-2"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <AddMoneyFlowModal account={account ?? undefined}>
              <Button
                variant="base-300"
                size="rounded-xl"
              //onClick={resetAddData}
              >
                <Plus2 className="min-h-6 min-w-6" />
              </Button>
            </AddMoneyFlowModal>
            <SendMoneyFlowModal>
              <Button className="size-14 rounded-full p-0" variant="base-300">
                <ArrowUpRight className="min-h-6 min-w-6" />
              </Button>
            </SendMoneyFlowModal>
            {/* TODO: restore Exchange */}
            {/* <Button
              className="size-14 rounded-full p-0"
              variant="base-300"
              onClick={handleGoToExchange}
            >
              <RightLeftArrow className="min-h-6 min-w-6" />
            </Button> */}
          </div>
        </div>
      </div>
    </>
  );
};
